import { Injectable, signal } from '@angular/core';

/**
 * Gate the in-Angular branded splash that overlays the shell from first paint
 * until `bootstrapFromFragment` completes. Synchronous today, but kept as a
 * service so a future async boot step can re-block without rewiring callers.
 */
@Injectable({ providedIn: 'root' })
export class BootStateService {
  readonly ready = signal(false);

  markReady(): void {
    this.ready.set(true);
  }
}
